export const SET_CONTACT_DIALOG_OPEN = 'SET_CONTACT_DIALOG_OPEN';
export const SET_CONTACT_DIALOG_DATA = 'SET_CONTACT_DIALOG_DATA';

export const setContactDialogOpen = (payload) => ({ type: SET_CONTACT_DIALOG_OPEN, payload });
export const setContactDialogData = (payload) => ({ type: SET_CONTACT_DIALOG_DATA, payload });
